'use strict';

import globals from './lib/globals';
import Logger from "./utilities/Logger";

// Bootstrap global functionality
globals();

const NAME = 'CONTACT';
Logger.log(NAME);

/**
 * Page-specific logic below
 **/
